import React, { useState, useEffect, useRef, useContext } from "react";
import { makeStyles } from "@mui/styles";
import ShowHTML from "../../../sharedComponents/HTMLEditor/ShowHTML";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
}));

const OtherView = (props) => {
  const classes = useStyles();
  const [description, setDescription] = useState(props.data && props.data.description ? props.data.description : "");
  useEffect(() => {
    setDescription(props.data && props.data.description ? props.data.description : "");
  })
  return (
    <div className={classes.root}>
      <ShowHTML heading="Other Details" data={description} />
    </div>
  );
};

export default OtherView;
